// Version : 1.0.0
// Author : AGALYA

import PancardDetailsActionType from './pancard-details.types';

/** ***************** Pancard Update Start ************************/
export const updatePancardStart = (pancardCredentials: any) => ({
	type: PancardDetailsActionType.UPDATE_PANCARD_START,
	payload: pancardCredentials,
});

export const updatePancardSuccess = (pancardSuccess: any) => ({
	type: PancardDetailsActionType.UPDATE_PANCARD_SUCCESS,
	payload: pancardSuccess,
});

export const updatePancardFailure = (pancardFailure: unknown) => ({
	type: PancardDetailsActionType.UPDATE_PANCARD_FAILURE,
	payload: pancardFailure,
});

export const updatePancardResponseResetStart = () => ({
	type: PancardDetailsActionType.UPDATE_PANCARD_RESPONSE_REST_START,
});

export const updatePancardResponseChanged = () => ({
	type: PancardDetailsActionType.UPDATE_PANCARD_RESPONSE_CHANGED,
});

/** ***************** Pancard Update Start ************************/
